import { theme } from "twin.macro";

import { type PaymentOrder } from "@/services/ordersV2/type";

export const tagsTheme = {
  pending: {
    name: "Pendiente",
    backgroundColor: theme`colors.neutral.90`,
    color: theme`colors.neutral.50`,
    borderColor: theme`colors.neutral.90`,
  },
  created: {
    name: "Creado",
    backgroundColor: theme`colors.neutral.90`,
    color: theme`colors.neutral.50`,
    borderColor: theme`colors.neutral.90`,
  },
  payInProcess: {
    name: "Pago en proceso",
    backgroundColor: theme`colors.primaryV2.90`,
    color: theme`colors.primaryV2.60`,
    borderColor: theme`colors.primaryV2.90`,
  },
  preparing: {
    name: "En preparación",
    backgroundColor: theme`colors.primaryV2.85`,
    color: theme`colors.primaryV2.40`,
    borderColor: theme`colors.primaryV2.85`,
  },
  prepared: {
    name: "Preparado",
    backgroundColor: theme`colors.primaryV2.85`,
    color: theme`colors.primaryV2.40`,
    borderColor: theme`colors.primaryV2.85`,
  },
  onWay: {
    name: "En camino",
    backgroundColor: theme`colors.tertiary.90`,
    color: theme`colors.tertiary.60`,
    borderColor: theme`colors.tertiary.90`,
  },
  reclaim: {
    name: "Reclamar",
    backgroundColor: theme`colors.secondary.85`,
    color: theme`colors.secondary.40`,
    borderColor: theme`colors.secondary.85`,
  },
  completed: {
    name: "Entregado",
    backgroundColor: theme`colors.tertiary.90`,
    color: theme`colors.tertiary.40`,
    borderColor: theme`colors.tertiary.90`,
  },
  canceled: {
    name: "Cancelado",
    backgroundColor: theme`colors.error.90`,
    color: theme`colors.error.50`,
    borderColor: theme`colors.error.90`,
  },
  rejected: {
    name: "Rechazado",
    backgroundColor: theme`colors.complement.80`,
    color: theme`colors.complement.10`,
    borderColor: theme`colors.complement.80`,
  },
};

export const validateAmountWithPayments = (
  payments: PaymentOrder[] | undefined,
  total: string | undefined
) => {
  if (total && payments && payments?.length > 0) {
    let amount = 0;

    for (let i = 0; i < payments.length; i++) {
      const payment = payments[i];

      if (payment.status === "confirmed") {
        amount += payment.total;
      }
    }

    return +amount >= +total;
  }

  return false;
};

export function cleanNullValues<T>(input: T): T {
  if (Array.isArray(input)) {
    return input
      .map((item) => cleanNullValues(item)) // Limpia valores en arrays recursivamente
      .filter((item) => item !== null && item !== undefined) as T;
  } else if (typeof input === "object" && input !== null) {
    return Object.keys(input).reduce((acc: T, key) => {
      const value = (input as Record<string, any>)[key];
      if (value !== null && value !== undefined) {
        (acc as Record<string, any>)[key] = cleanNullValues(value);
      }
      return acc;
    }, {} as T);
  }
  return input;
}
